import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=4fa0346b&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=4fa0346b&prod&lang=scss"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=4fa0346b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa0346b",
  null
  
)

export default component.exports